import {Icon, Menu} from 'ant-design-vue';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class Menus extends Vue
{
    /**
     * 当前菜单数据
     * @protected
     * @returns boolean
     */
     @Prop({type: Array, required: true})
    protected menu: Array<any>;

    /**
     * 菜单主题
     * @protected
     * @returns string
     */
      @Prop({type: String, default: "dark"})
      protected theme: string;

    /**
     * 菜单模式
     * @protected
     * @returns string
     */
      @Prop({type: String, default: "inline"})
      protected mode: string;

    /**
     * 当前菜单状态
     * @protected
     * @returns boolean
     */
    @Prop({type: Boolean, default: false})
    protected collapsed: boolean;

    /**
     * 展开的菜单的key
     * @protected
     * @returns Array<string | number>
     */
    private openKeys: Array<string | number> = [];

    /**
     * 选中菜单的key
     * @protected
     * @returns Array<string | number>
     */
    private selectedKeys: Array<string | number> = [];

    /**
     * 缓存选中菜单的key
     * @protected
     * @returns Array<string | number>
     */
    private cachedOpenKeys: Array<string | number> = [];

    /**
     * 当前菜单所有的path
     * @protected
     * @returns Array<string | number>
     */
    private get rootSubmenuKeys(): Array<string | number>
    {
        const keys: Array<string | number> = [];
        this.menu.forEach((item: any) => keys.push(item.path));
        return keys;
    }

    /**
     * 页面dom元素架子啊
     * @protected
     * @returns void
     */
    protected mounted()
    {
        this.updateMenu()
    }

    /**
     * 监听菜单展开/收起变化
     * @protected
     * @returns void
     */
    @Watch("collapsed")
    private onCollapsedChange(val: boolean)
    {
        if(val)
        {
            // 当菜单收起时，存储已经打开菜单
            this.cachedOpenKeys = this.openKeys.concat()
            this.openKeys = []
        }
        else
        {
            this.openKeys = this.cachedOpenKeys
        }
    }

    /**
     * 监听路由发生变化
     * @protected
     * @returns void
     */
    @Watch("$route")
    private onRouteChange(val: boolean)
    {
        this.updateMenu();
    }

    /**
     * SubMenu 展开/关闭的回调
     * @param openKeys 
     * @returns 
     */
    private onOpenChange (openKeys: Array<string>)
    {
        // 在水平模式下时执行，并且不再执行后续
        if (this.mode === 'horizontal') {
            this.openKeys = openKeys;
            return
        }

        // 非水平模式时
        const latestOpenKey = openKeys.find(key => !this.openKeys.includes(key)) || "";
        if (!this.rootSubmenuKeys.includes(latestOpenKey))
        {
            this.openKeys = openKeys
        }
        else
        {
            this.openKeys = latestOpenKey ? [latestOpenKey] : []
        }
    }

    /**
     * 菜单选中时
     * @param openKeys 
     * @returns 
     */
    protected onSelect({ item, key, selectedKeys }:{item: any, key: string, selectedKeys: Array<number | string>})
    {
        this.selectedKeys = selectedKeys
        this.$emit('select', { item, key, selectedKeys })
    }

    /**
     * 更新菜单
     * @returns 
     */
    protected updateMenu ()
    {
        const routes: Array<any> = this.$route.matched.concat();

        const { hidden } = this.$route.meta
        let path: string = this.$route.path,
            paths: Array<string> = path.replace(/^/, "").split("/");

        if (routes.length >= 3 && hidden)
        {
            routes.pop()
        }

        if(paths.length == 4)
        {
            this.selectedKeys = [paths[paths.length-2]]
        }
        else
        {
            this.selectedKeys = [paths[paths.length-1]]
        }
        
        const openKeys: Array<any> = [];

        if (this.mode === 'inline')
        {
            routes.forEach(item =>
            {
                openKeys.push(item.path)
            })
        }

        this.collapsed ? (this.cachedOpenKeys = openKeys) : (this.openKeys = openKeys)
    }

    /**
     * 渲染item
     * @param menu 
     * @returns 
     */
    protected renderItem (menu: any)
    {
       
        if (!menu.hidden)
        {
            return menu.children && !menu.hideChildrenInMenu ? this.renderSubMenu(menu) : this.renderMenuItem(menu)
        }

        return null
    }

    /**
     * 渲染菜单item
     * @param menu 
     * @returns 
     */
    private renderMenuItem(menu: any)
    {
        const target = menu.meta.target || null
        const CustomTag = target && 'a' || 'router-link'
        const props = { to: { name: menu.name } }
        const attrs = { href: menu.path, target: menu.meta.target }

        if (menu.children && menu.hideChildrenInMenu)
        {
            // 把有子菜单的 并且 父菜单是要隐藏子菜单的
            // 都给子菜单增加一个 hidden 属性
            // 用来给刷新页面时， selectedKeys 做控制用
            menu.children.forEach((item: any) => {
                item.meta = Object.assign(item.meta, { hidden: true })
            })
        }

        return (
            <Menu.Item {...{ key: menu.name }}>
                <CustomTag {...{ props, attrs }}>
                    {this.renderIcon(menu.meta.icon)}
                    <span>{menu.meta.title}</span>
                </CustomTag>
            </Menu.Item>
        )
    }

    /**
     * 渲染二级菜单
     * @param menu 
     * @returns 
     */
    private renderSubMenu (menu: any) {
        const itemArr: Array<any> = []
        if (!menu.hideChildrenInMenu) {
            menu.children.forEach((item: any) => itemArr.push(this.renderItem(item)))
        }
        return (
            <Menu.SubMenu {...{ key: menu.path }}>
            <span slot="title">
                {this.renderIcon(menu.meta.icon)}
                <span>{menu.meta.title}</span>
            </span>
            {itemArr}
            </Menu.SubMenu>
        )
    }

    /**
     * 渲染图标
     * @param icon 
     * @returns 
     */
    private renderIcon (icon: any) {
        if (icon === 'none' || icon === undefined) {
            return null
        }
        const props: any = {}
        typeof (icon) === 'object' ? props.component = icon : props.type = icon
        return (
            <Icon {... { props } }/>
        )
    }

    /**
     * 渲染页面
     * @param h 
     * @returns 
     */
    private render (h: any)
    {
        const dynamicProps = {
            props: {
            mode: this.mode,
            theme: this.theme,
            openKeys: this.openKeys,
            selectedKeys: this.selectedKeys
            },
            on: {
                openChange: this.onOpenChange,
                select: this.onSelect
            }
        }

        const menuTree = this.menu.map(item => {
            if (item.hidden) {
                return null
            }
            return this.renderItem(item)
        })
            
        return (<Menu {...dynamicProps}>{menuTree}</Menu>)
    }
}
